'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

exports['default'] = function ($translateProvider) {
	'ngInject';

	$translateProvider.translations('bg', {
		'ABOUT_US': {
			'LABEL': 'За нас',
			'GROUP': '"ГРУП" ООД и "Моди Транс" ООД.',
			'PARAGRAPH_ONE_CONTENT': 'Ние сме първите, ние сме най-добрите - ние сме ',
			'PARAGRAPH_TWO_CONTENT': 'Няма човек в България, който да не знае, че "ГРУП" ООД е фирма за автобусен транспорт и то най-добрата. Създадена преди 20 години, фирмата бързо заема полагащото й се първо място в България. Комфортни автобуси, опитни шофьори, любезен персонал, приятно пътуване - това предлага "ГРУП" ООД на своите клиенти. Но Вие знаете това, нали?',
			'PARAGRAPH_THREE_CONTENT': 'Ако не сте ползували нашите услуги, имате възможност да се убедите, но трябва да побързате.',
			'PARAGRAPH_FOUR_CONTENT': 'Чакаме Ви с нашите международни автобусни линии: ',
			'PARAGRAPH_FIFTH_CONTENT': 'София - Будапеща - Братислава - Бърно - Прага - София всеки ден от 10 часа.',
			'PARAGRAPH_SIXTH_CONTENT': 'Автобусите ни тръгват от Трафик маркет / пред Централна гара / . ',
			'PARAGRAPH_SEVENTH_CONTENT': 'Централният ни офис също се намира на Трафик маркет - офис № 41, офис № 87',
			'PHONE_ONE': '02/ 980 63 36',
			'PHONE_TWO': '02/ 981 42 13',
			'PHONE_THREE': '0878 215 150',
			'PHONE_FOUR': '02/ 981 42 78 - тел/факс.'
		}
	}).translations('en', {
		'ABOUT_US': {
			'LABEL': 'About Us',
			'GROUP': '"GROUP" Ltd. and "Modi Trans" Ltd.',
			'PARAGRAPH_ONE_CONTENT': 'We are the first, we are the best - we are ',
			'PARAGRAPH_TWO_CONTENT': 'There is no one in Bulgaria who does not know that "GROUP" Ltd is the best company for bus transportation. Established 20 years ago, the company quickly takes her rightful first place in Bulgaria. Comfortable buses, experienced drivers, friendly staff, pleasant journey - this is what "Group" Ltd has to offer to its clients. But you know that, right?',
			'PARAGRAPH_THREE_CONTENT': 'If you have not used our services, you heve the opportunity, but you must hurry.',
			'PARAGRAPH_FOUR_CONTENT': 'We are waiting for you with out internation bus lines: ',
			'PARAGRAPH_FIFTH_CONTENT': 'Sofia - Budapest - Bratislava - Brno - Praha - Sofia every day from 10 o\'clock.',
			'PARAGRAPH_SIXTH_CONTENT': 'Our buses leave from Traffic Market / in front of Central Station /. Our Head office is also located on Traffic Market - Office № 41, office № 87, phones: ',
			'PARAGRAPH_SEVENTH_CONTENT': '',
			'PHONE_ONE': '003592/ 980 63 36',
			'PHONE_TWO': '003592/ 981 42 13 ',
			'PHONE_THREE': '003592/ 0878 215 150',
			'PHONE_FOUR': '003592/ 981 42 78 - tel/fax.'
		}
	}).translations('cz', {
		'ABOUT_US': {
			'LABEL': 'Pro nás',
			'GROUP': 'GROUP s.r.o. a Modi Trans s.r.o.',
			'PARAGRAPH_ONE_CONTENT': 'My jsme první, my jsme nejlepší – my jsme',
			'PARAGRAPH_TWO_CONTENT': 'Není člověka v Bulharsku, aby nevěděl, že GROUP,s.r.o. je firma pro autobusovou přepravu a to nejlepší. Vznikla před 20 lety a rychle zaujímá patřící jí první místo v Bulharsku. Komfortní autobusy, zkušení šoféři, vlídný personal, příjemné cestování – to GROUP,s.r.o. nabízí svým zákazníkům. Vy to ale víte, že? ',
			'PARAGRAPH_THREE_CONTENT': 'Pokud jste nevyužili našich služeb, máte možnost se o tom přesvědčit, ale pospěšte si.',
			'PARAGRAPH_FOUR_CONTENT': 'Čekáme Vás s našimi mezinárodními autobusovými linkami:',
			'PARAGRAPH_FIFTH_CONTENT': 'Sofie - Budapešt - Bratislava - Brno - Praha – Sofie denně od 10 hod.',
			'PARAGRAPH_SIXTH_CONTENT': 'Telephony:',
			'PARAGRAPH_SEVENTH_CONTENT': '',
			'PHONE_ONE': '003592/ 980 63 36',
			'PHONE_TWO': '003592/ 981 42 13 ',
			'PHONE_THREE': '003592/ 0878 215 150',
			'PHONE_FOUR': '003592/ 981 42 78 - tel/fax.'
		}
	}).translations('hu', {
		'ABOUT_US': {
			'LABEL': 'Rólunk',
			'GROUP': '"GROUP" Kft. és a "Modi Trans" Kft.',
			'PARAGRAPH_ONE_CONTENT': 'Mi vagyünk az elsők, mi vagyünk a legjobbak – mi vagyunk a ',
			'PARAGRAPH_TWO_CONTENT': 'Alig van olyan ember Bulgáriában, aki ne tudná, hogy "GROUP" Kft. az egyik legjobb autóbuszos személyszállító cég országszerte. 20 évvel ezelőtti alapítása óta Bulgária első számú személyszállító cégévé nőtte ki magát. A “GROUP Kft” utasait és megrendelőit kényelmes autóbuszok, tapasztalt sofőrök, kedves személyzet és kellemes utazás várja. Ön esetleg már tudja ezt rólunk?',
			'PARAGRAPH_THREE_CONTENT': 'Ha még nem vette igénybe szolgáltatásainkat most lehetősége nyílik meggyőződnie azokról.',
			'PARAGRAPH_FOUR_CONTENT': 'Szeretettel várjuk Önt nemzetközi útvonalainkon:',
			'PARAGRAPH_FIFTH_CONTENT': 'Szófia - Budapest - Poszony - Brno - Prága – Szófia. Indulás: minden nap 10 órakor.',
			'PARAGRAPH_SIXTH_CONTENT': 'Kapcsolat (Külföldről indított hívás esetén a körzetszám előtti 0-t el kell hagyni):',
			'PARAGRAPH_SEVENTH_CONTENT': '',
			'PHONE_ONE': 'pl. +359 2 980 6336',
			'PHONE_TWO': '02/ 980 63 36',
			'PHONE_THREE': '0878 215 150',
			'PHONE_FOUR': '02/ 981 42 78 - tel/fax.'
		}
	});
};

module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/public/main/about-us/about-us.locale.js
 **/